import React from 'react'

import SelectProjectMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/project-multi"
import SelectUsersMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/users-multi"
import SelectTaskTypeMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/task-types"
import SelectTaskSystemStatus from "../../../../app/quick-add/sections/view/components/forms/common-blocks/task-system-status"
import {SystemStatus} from "../../../gd/const/system-status"
import FormManager from "../../../gd-form/common/form-manager"
import quickAdd_getUsersIds from "../../../../app/quick-add/sections/view/components/forms/functions/get-users-ids"
import Views_convertStatusesToStatusString from "../../functions/convert-statuses-to-string"
import Views_convertStatusStringToStatuses from "../../functions/convert-string-to-statuses"
import CustomView from "../../../model2/custom-view/custom-view"
import {EntityType} from "../../../gd/const/item"

type BoardConditionsType = {
    projects            : ID[]
    users               : ID[]
    assignedToUsers     : ID[]
    actionRequiredUsers : ID[]
    taskTypes           : ID[]
    systemTaskStatuses  : SystemStatus[]
}

type Props = {
    className?  : string

    view        : CustomView
    disabled?   : boolean
    onChange    : { (conditions: BoardConditionsType):void }
}

// const debug = "ViewBoard_Conditions"
const debug = false


export default function ViewBoard_Conditions(props: Props) {

    debug && console.log(debug, 'render', props)

    const onUserChange = () => {
        debug && console.log(debug, 'onUserChange')

        const result = form.getValues()

        const conditions: BoardConditionsType = {
            projects            : result.projects,
            users               : result.users,
            assignedToUsers     : result.assignedToUsers,
            actionRequiredUsers : result.actionRequiredUsers,
            taskTypes           : result.taskTypes,
            systemTaskStatuses  : Views_convertStatusStringToStatuses(result.status)
        }

        debug && console.log(debug, 'onUserChange conditions', conditions)

        props.onChange(conditions)
    }

    const updateUsersField = (name: string, allUserIds: ID[]) => {
        const users = form.getValue(name);
        const newUsers = _.intersection(users, allUserIds)
        form.setFieldValue(name, newUsers)
    }

    const onParentSelect = (projects: ID[]) => {
        debug && console.log(debug, 'onParentSelect')

        form.onFormComponentValueChange('projects', projects)

        const newUsers = quickAdd_getUsersIds(projects)

        updateUsersField('users', newUsers)
        updateUsersField('assignedToUsers', newUsers)
        updateUsersField('actionRequiredUsers', newUsers)

        onUserChange()
    }

    const conditions = props.view.settings

    const initFormData: any = {
        projects            : conditions?.projects || [],
        users               : conditions?.users || [],
        assignedToUsers     : conditions?.assignedToUsers || [],
        actionRequiredUsers : conditions?.actionRequiredUsers || [],
        taskTypes           : conditions?.taskTypes || [],
        status              : Views_convertStatusesToStatusString(conditions?.systemTaskStatuses),
    }

    const formStructure = {
        fields          : {
            projects            : { type: 'select',   isRequired: false,  label: 'Projects'},
            users               : { type: 'select',   isRequired: false,  label: 'Users',                   onUserChange: onUserChange},
            assignedToUsers     : { type: 'select',   isRequired: false,  label: 'Users',                   onUserChange: onUserChange},
            actionRequiredUsers : { type: 'select',   isRequired: false,  label: 'Users',                   onUserChange: onUserChange},
            taskTypes           : { type: 'select',   isRequired: false,  label: 'Task types',              onUserChange: onUserChange},
            status              : { type: 'select',   isRequired: false,  label: 'System task statuses',    onUserChange: onUserChange},
        },
        isFormChanged   : true,
    }

    const form = new FormManager(formStructure, initFormData);

    const projectsIds = form.getValue('projects') || []
    const usersIds = quickAdd_getUsersIds(projectsIds)

    const companyTaskTypes = gd.session.taskTypes.filterByCompany(gd.companyId)
    const allowedTaskTypes = _.map(companyTaskTypes.models, tt => tt.id)

    const classes = Classes("ui5-form", props.className)

    return (
        <div className={classes}>
            <div className="tbl">
                <SelectProjectMulti form            = {form}
                                    formFieldName   = 'projects'
                                    parentsFor      = {EntityType.PROJECT}
                                    disabled        = {props.disabled}
                                    onParentSelect  = {onParentSelect}/>

                <SelectUsersMulti label         = "Users"
                                  form          = {form}
                                  formFieldName = 'users'
                                  usersIds      = {usersIds}
                                  disabled      = {props.disabled}/>

                <SelectUsersMulti label         = "Assigned to users"
                                  form          = {form}
                                  formFieldName = 'assignedToUsers'
                                  usersIds      = {usersIds}
                                  disabled      = {props.disabled}/>

                <SelectUsersMulti label         = "Action required users"
                                  form          = {form}
                                  formFieldName = 'actionRequiredUsers'
                                  usersIds      = {usersIds}
                                  disabled      = {props.disabled}/>

                <SelectTaskTypeMulti form               = {form}
                                     formFieldName      = 'taskTypes'
                                     allowedTaskTypes   = {allowedTaskTypes}
                                     disabled           = {props.disabled}/>

                <SelectTaskSystemStatus form            = {form}
                                        formFieldName   = 'status'
                                        disabled        = {props.disabled}/>
            </div>
        </div>
    )
}